import { WaterIcon } from './WaterIcon';

/**
 * author: Google
 * id 17EEE663-92E4-4AB1-87FE-94F2CD296C4B
 * name water
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water.svg
 * tags
 * - Home Automation 
 * - Health / Beauty 
 * - Food / Drink 
 * - Weather 
 * - Agriculture 
 */
export const TransFatIcon = WaterIcon;
export default TransFatIcon